export var startScreenRecording = function () {
    var msg = {
        type: "io.bugpilot.events.start-screen-recording",
    };
    window.postMessage(msg, "*");
};
export var sendReport = function (_a) {
    var email = _a.email, description = _a.description;
    var msg = {
        type: "io.bugpilot.events.send-report",
        data: { email: email, description: description },
    };
    // @TODO: also send widgetStartTime, widgetFinishTime,
    // and add them to metadata (see Bugpilot.ts)
    window.postMessage(msg, "*");
};
export var getUserEmail = function () {
    var _a, _b, _c;
    var w = window;
    return ((_c = (_b = (_a = w.Bugpilot) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.email) || "";
};
